import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceDataService } from '../services/reference-data.service';

@Pipe({ name: 'localizeOption' })
export class LocalizeOptionPipe implements PipeTransform {
  constructor(private referenceDataService: ReferenceDataService) {}

  transform(code: string, optionListName: string): string {
    const option = this.referenceDataService.getOptionListConfigItems(optionListName).filter((o) => o.Code === code)[0];

    return option ? option.Value : code;
  }
}
